import { DashboardUseCaseCounts } from '@api';
import { depaginate, useApi } from '@data-access';
import { RiskMatrixDashboard } from '@sections/DashboardCharts/RiskMatrixDashboard/RiskMatrixDashboard';
import { riskProfileStore } from '@stores/riskProfile.store';
import { observer } from 'mobx-react';
import { useCallback, useEffect } from 'react';
import { DashboardApiFilterParameters } from 'src/pages/dashboard';

import { ChartCard } from '../ChartCard/ChartCard';
import { RiskAssessmentSection } from '../RiskAssessmentSection/RiskAssessmentSection';

import styles from './TwoDimensionsChart.module.scss';

interface TwoDimensionsChartProps {
  appliedFilters: DashboardApiFilterParameters;
  riskAssessment: DashboardUseCaseCounts['riskAssessment'];
}

export const TwoDimensionsChart: React.FC<TwoDimensionsChartProps> = observer(({ appliedFilters, riskAssessment }) => {
  const { api, riskProfileApi } = useApi();
  const {
    residualRisks,
    dimensionRiskLabels,
    numberOfDimensions,
    setResidualRisks,
    setDimensionRiskLabels,
    setNumberOfDimensions,
  } = riskProfileStore;

  const fetchAllData = useCallback(async () => {
    try {
      const [fetchResidualRisksLabels, fetchDimensionLabels, fetchedDimensions] = await Promise.all([
        depaginate(page => riskProfileApi?.apiResidualRiskLabelsList({ page })),
        depaginate(page => riskProfileApi?.apiDimensionLabelsList({ page })),
        depaginate(page => api?.apiRiskDimensionLabelNameList({ page })),
      ]);

      setResidualRisks(fetchResidualRisksLabels);
      setDimensionRiskLabels(fetchDimensionLabels);
      setNumberOfDimensions(fetchedDimensions.length);
    } catch (error) {
      console.log(error);
    }
  }, [setResidualRisks, setDimensionRiskLabels, setNumberOfDimensions, riskProfileApi, api]);

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  return (
    <ChartCard
      title="Operational Residual Risk"
      subtitle=""
      className={styles.card}
    >
      <RiskAssessmentSection riskAssessment={riskAssessment} />
      {residualRisks?.length > 0 && dimensionRiskLabels?.length > 0 && numberOfDimensions === 2 ? (
        <RiskMatrixDashboard appliedFilters={appliedFilters} />
      ) : (
        <div className={styles.noData}>No data</div>
      )}
    </ChartCard>
  );
});
